import { useState } from 'react';

import { useBoolean, useUpdateEffect } from 'usehooks-ts';

import { HTTP_TOO_MANY_REQUESTS } from '../constants';
import usePostPromoCode from './usePostPromoCode';
import useWriteCartData from './useWriteCartData';

const MAX_PROMO_CODE_TRIES = 10;

const useFormPromoCode = (teamId, cartOrderId) => {
  const [promoCode, setPromoCode] = useState('');

  const { data, status, writePromoCode, triesCount, statusCode } = usePostPromoCode(teamId, cartOrderId);

  const { value: promoCodeSuccess, setValue: setPromoCodeSuccess } = useBoolean(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const { setCartDataToWrite } = useWriteCartData();

  const isRateLimited = statusCode === HTTP_TOO_MANY_REQUESTS;
  const isLimitReached = triesCount >= MAX_PROMO_CODE_TRIES;
  const triesLeft = MAX_PROMO_CODE_TRIES - triesCount;
  const isDisabled = isLimitReached || isRateLimited;

  const onSubmitCode = e => {
    e.preventDefault();
    if (!promoCode) return;
    if (isDisabled) return;

    // If same code submitted then canWrite will be false
    const canWrite = writePromoCode(promoCode);
    setIsSubmitting(canWrite);
  };

  useUpdateEffect(() => {
    // When react reloads state
    if (!data) return;

    setIsSubmitting(false);

    // success is when backend replies with a cart
    const success = 'order' in data;
    setPromoCodeSuccess(success);
    if (success) {
      setPromoCode('');
      setCartDataToWrite(data);
    }
  }, [data]);

  return { onSubmitCode, isSubmitting, promoCode, setPromoCode, promoCodeSuccess, status, data, isDisabled, triesLeft };
};

export default useFormPromoCode;
